<template>
  <a-modal title="添加"
           :open="modal"
           :confirm-loading="loading"
           ok-text="保存" @ok="okCk"
           cancel-text="关闭" @cancel="cancelCk">
    <div class="search-nav">
      <a-form ref="form"
              size="small"
              :rules="rules"
              :model="entity"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 20 }">
        <a-form-item label="类型" name="type">
          <a-select :options="typeList" v-model:value="entity.type"/>
        </a-form-item>

        <a-form-item label="文件" name="link">
          <a-input v-model:value="entity.link"/>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'

const emits = defineEmits(['refresh'])

const modal = ref(false)
const loading = ref(false)
const entity = ref({
  site: 0,
  type: 0,
  link: '',
})

const typeList = [
  {
    value: 0,
    label: '图片',
  }, {
    value: 1,
    label: '视频',
  },
]

let itemId = 0

function openCk(id, site) {
  itemId = id
  entity.value.site = site
  entity.value.link = []
  modal.value = true
}

function okCk() {
  if (!entity.value.link) {
    return
  }
  loading.value = true
  let param = entity.value
  param.link = [param.link]
  axios.post(`/item/${itemId}/thumb`, param).then((res) => {
    loading.value = false

    if (res.code === 1) {
      emits('refresh')
      modal.value = false
    }
  })
}

function cancelCk() {
  modal.value = false
  loading.value = false
}

defineExpose({openCk})
</script>

<style scoped>
.search-nav {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.selector {
  width: 68px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.txt-center {
  text-align: center;
}

:deep(.ant-checkbox-wrapper) {
  align-items: center;
}
</style>
